import { Image } from "@mantine/core";
import { Link, useParams, useRouteLoaderData } from "@remix-run/react";

import Logo from "~/assets/misc/logo.png";
import { LanguageToggle } from "~/components/language-toggle";
import { useTranslation } from "~/hooks/use-typed-translation";
import { loader as rootLoader } from "~/root";
import utilityClasses from "~/styles/utilities.module.scss";

import classes from "./navbar.module.scss";

export const Navbar = ({ className }: { className?: string }) => {
  const { i18n } = useTranslation();
  const { lang } = useParams();
  const rootData = useRouteLoaderData<typeof rootLoader>("root");
  const partnerLogo = rootData?.partnerData?.logo;
  const partnerName = rootData?.partnerData?.name;

  return (
    <section className={classes.section}>
      <div className={utilityClasses.container}>
        <nav className={`${classes.nav} ${className}`}>
          <Link
            reloadDocument
            to={`/${lang && i18n.languages.includes(lang) ? lang : ""}`}>
            <Image 
              src={partnerLogo || Logo} 
              alt={partnerName || "La Ruche Health"} 
              h={30}
              w="auto"
              fit="contain"
              styles={{
                root: {
                  maxWidth: "100px"
                }
              }}
            />
          </Link>
          <LanguageToggle />
        </nav>
      </div>
    </section>
  );
};
